import Base, { yup } from './Base';

const schema = yup.object().shape({
  description: yup.string().nullable(),
  privacy: yup.string().required('Privacy is required'),
  title: yup.string().required('Title is required'),
});

export default class TemplateModel extends Base {
  static validateData(item, fields) {
    return super.validate(item, fields, schema);
  }

  title = '';
  description = '';
  privacy = '';
}
